<template>
  <Tippy
    tag="a"
    href="javascript:;"
    class="tooltip"
    content="Print Selected Labels"
    :options="{
      zIndex: 99999,
    }"
  >
    <a
      href="javascript:;"
      @click="buttonClick()"
      class="mr-2 btn btn-primary shadow-md text-xs hover:text-yellow-200 mt-1 mb-1"
    >
      Print Labels
      <span class="ml-2">
        <PrinterIcon class="lg:w-6 lg:h-6 w-4 h-4 ml-2 mr-2" />
      </span>
    </a>
  </Tippy>
</template>
<script>
export default {
  props: { buttonName: "" },
  name: "PrintLabels",
  methods: {
    buttonClick() {
      this.$emit("parentMethod");
    },
  },
};
</script>
